import React from "react"
import { AnimatePresence } from "framer-motion"
import { Container, Holder } from "./PopupDialog.style"

export default function PopupDialog({ show, children }) {
  return (
    <AnimatePresence>
      {show && (
        <Holder
          exit={{ y: "100vh", opacity: 1 }}
          initial={{ y: "100vh", opacity: 1 }}
          animate={{ y: "0", opacity: 1 }}
          transition={{
            type: "spring",
            stiffness: 150,
            damping: 50,
            mass: 1.7
          }}
        >
          <Container>{children}</Container>
        </Holder>
      )}
    </AnimatePresence>
  )
}
